var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"section is-tiny footer is-dark text-centered"},[_c('nav',{staticClass:"container"},[_c('app-navigation',{staticClass:"justify-center"})],1),_c('span',[_vm._v("© "+_vm._s(_vm.year)+" Mike Kutnik")])])}
var staticRenderFns = []

export { render, staticRenderFns }